"use client";
import { useEffect, useState } from 'react';
import style from './broadcastNotification.module.scss';
import BroadcastEntity from './broadcast-entity/BroadcastEntity';
import Close from '../svg/Close';
import { useLocale } from 'next-intl';
import { usePathname } from 'next/navigation';
import BroadcastEntityDto from '@/projectRoot/api-client/interfaces/models/broadcast/BroadcastEntity.dto';

interface Props {
    entity: BroadcastEntityDto;
    leaveChannel: () => void;
    classes?: string[];
}

const BroadcastNotification = ({entity, leaveChannel, classes = []}: Props) => {
    // console.log('new instance: ', entity)
    const locale = useLocale();
    const [entities, setEntities] = useState<BroadcastEntityDto[]>([]);
    const pathname = usePathname();

    const onClickHandleClose = () => {
        // leaveChannel();
        setEntities([]);
    }

    useEffect(() => {
        // setEntities([...entities, entity]);
        setEntities((prevState) => {
            const exists = entities.some(
                (item) => item.sequence_number === entity.sequence_number
            );
            
            if(exists){
                return [...prevState];
            }

            return [...prevState, entity];
        });
    }, [entity]);

    useEffect(() => {
        setEntities((prevState) => {
            let newState = prevState.filter(ent => ent.multilang_slugs[locale] !== window.location.href);
            return newState;
        });
    }, [pathname]);

  return (
    entities && entities.length > 0 && entity
    ?
    <div className={`${style.notificationPopup} ${classes.join(' ')}`}>
        <p className={style.title}>
            {entities[entities.length - 1]?.message}
        </p>
        <span className={style.close} onClick={onClickHandleClose}>
            <Close />
        </span>
        <div className={style.entities}>
            {
                entities.map(ent => <BroadcastEntity classes={[style.entity]} entity={ent} key={ent.id} />)
            }
        </div>
    </div>
    : <></>
  )
};

export default BroadcastNotification;
